/**
 * User: herbert
 * Date: 20.02.16
 * Time: 21:45
 */

import Reflux from 'reflux';

export default Reflux.createActions({
	/** set option
	 * @param{config.Options} options */
	set: {},
	/** choose if and what spot of a twinspot is selected
	 * @param{Boolean} a true if Spot a is selected, but not Spot b
	 * @param{Boolean} b true if Spot b is selected, but not Spot a
 	 */
	setSpot: {},
	/** clear option dialog */
	clear: {}
});
